<template>
  <div >
    <vs-prompt
      vs-title="Müşteri Ekle"
      vs-accept-text="Ekle"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      :vs-is-valid="validateForm"
      @vs-cancel="clearFields"
      @vs-accept="setCustomer(customerModel)"
      @vs-close="clearFields"
      :vs-active.sync="addNewRegister"
    >
      <div>
        <form>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5">
              <label>Adı Soyadı</label>
              <span v-show="errors.has('namesurname')" class="errorfonts">{{ errors.first("namesurname") }}</span>
              <vs-input v-validate="'required'" name="namesurname" class="w-full" icon-pack="feather" icon="icon-user" :color="validateForm ? 'success' : 'danger'" icon-no-border v-model="customerModel.customerName" />
            </div>

            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5">
              <label>Mail Adresi</label>
              <span v-show="errors.has('mailaddress')" class="errorfonts">{{ errors.first("mailaddress") }}</span>
              <vs-input type="email" name="mailaddress" class="w-full" :color="validateForm ? 'success' : 'danger'" icon-pack="feather" icon="icon-mail" icon-no-border v-model="customerModel.customerMail" />
            </div>
          </div>

          <div class="vx-row ">
            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5 ">
              <label>Telefon</label>
              <span v-show="errors.has('telephone')" class="errorfonts">{{ errors.first("telephone") }}</span>
              <vs-input class="w-full" icon-pack="feather" v-validate="'numeric'" name="telephone" icon="icon-smartphone" icon-no-border :color="validateForm ? 'success' : 'danger'" v-model="customerModel.phone" />
            </div>

            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5">
              <label>Adres</label>
              <span v-show="errors.has('address')" class="errorfonts">{{ errors.first("address") }}</span>
              <vs-input name="address" class="w-full" icon-pack="feather" icon="icon-book" :color="validateForm ? 'success' : 'danger'" icon-no-border v-model="customerModel.address" />
            </div>
          </div>

          <div class="vx-row ">
            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5 ">
              <label>Vergi No</label>
              <span v-show="errors.has('feeNumber')" class="errorfonts">{{ errors.first("feeNumber") }}</span>

              <vs-input name="feeNumber" class="w-full" icon-pack="feather" icon="icon-corner-down-right" v-validate="'numeric'" icon-no-border v-model="customerModel.taxNumber" />
            </div>

            <div class="vx-col sm:w-1/2 md:w-1/2 w-full" style="margin-top:30px">
              <span v-show="errors.has('countrySelection')" class="errorfonts">{{ errors.first("countrySelection") }}</span>
              <v-select name="countrySelection" v-model="customerModel.country" v-validate="'required'" placeholder="Ülke" :options="countries" label="value" class="w-full" :reduce="(countries) => countries.id" @input="getCities()">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
          </div>

          <div class="vx-row ">
            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5" >
              <span v-show="errors.has('feeCenter')" class="errorfonts">{{ errors.first("feeCenter") }}</span>

              <v-select
                name="feeCenter"
                class="w-full"
                icon-pack="feather"
                placeholder="Vergi Dairesi"
                icon="icon-briefcase"
                icon-no-border
                v-model="customerModel.taxOffice"
                label="value"
                :options="taxOfficeList"
                :reduce="(taxOfficeList) => taxOfficeList.id"
              >
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>

            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5">
              <span v-show="errors.has('citySelection')" class="errorfonts">{{ errors.first("citySelection") }}</span>
              <v-select name="citySelection" v-model="customerModel.city" placeholder="İl" :options="cities" v-validate="'required'" label="value" class="w-full" :reduce="(cities) => cities.id" @input="getCounties()">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
          </div>
          <div class="vx-row ">
            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5">
              <span v-show="errors.has('tagSelection')" class="errorfonts">{{ errors.first("tagSelection") }}</span>
              <v-select name="tagSelection" v-model="customerModel.tags" :closeOnSelect="false" placeholder="Etiket" :options="customerTags" label="value" class="w-full" multiple>
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>

            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5">
              <span v-show="errors.has('countySelection')" class="errorfonts">{{ errors.first("countySelection") }}</span>
              <v-select name="countySelection" v-validate="'required'" v-model="customerModel.county" placeholder="İlçe" :options="counties" label="value" class="w-full" :reduce="(counties) => counties.id">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
          </div>

          <div class="vx-row ">
            <!-- <div class="vx-col sm:w-1/2 w-1/2">
               <span
                v-show="errors.has('salesStaff')"
                class="errorfonts"
              >{{ errors.first('salesStaff') }}</span>
              <v-select
                name="salesStaff"
                v-model="customerModel.userId"
                placeholder="Müşteri Temsilcisi"
                :options="salesStaff"
                label="teamName"
                class="w-full"
              ></v-select>
            </div>-->

            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5">
              <vs-checkbox v-if="withAdditionalData" v-model="customerModel.isOnlineCustomer">Pazaryeri Müşterisi</vs-checkbox>
            </div>

            <div class="vx-col sm:w-1/2 md:w-1/2 w-full mt-5">
              <vs-checkbox v-model="customerModel.isSupplier">Tedarikçi</vs-checkbox>
            </div>
          </div>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import { Validator } from "vee-validate";
import { globalFunctions } from "../../../_services/globalFunctions";

const dict = {
  custom: {
    namesurname: {
      required: "Ad soyad zorunludur!",
    },
    telephone: {
      numeric: "Telefon numaranız sadece rakamlardan oluşabilir.",
    },
    tagSelection: {
      required: "Etiket seçimi zorunludur!",
    },
    address: {
      required: "Adres alanı zorunludur!",
    },
    countrySelection: {
      required: "Ülke seçimi zorunludur!",
    },
    citySelection: {
      required: "İl seçimi zorunludur!",
    },
    countySelection: {
      required: "İlçe seçimi zorunludur!",
    },
    salesStaff: {
      required: "Müşteri Temsilcisi seçimi zorunludur!",
    },
    feeNumber: {
      numeric: "Sadece rakam lütfen",
    },
  },
};
Validator.localize("tr", dict);

export default {
  components: {
    vSelect,
  },
  props: {
    addnew: {
      type: Boolean,
      required: true,
    },
    withAdditionalData: {
      type: Boolean,
      required: true,
    },
    phone: null,
  },
  data() {
    return {
      countries: [],
      taxOfficeList: [],
      cities: [],
      counties: [],
      salesStaff: [],
      customerTags: [],
      lockSaving: false,
      customerModel: {
        customerName: "",
        customerMail: null,
        address: "",
        phone: this.phone,
        tags: "",
        country: 52,
        city: 0,
        county: 0,
        taxOffice: "",
        taxNumber: null,
        isOnlineCustomer: false,
      },
    };
  },

  computed: {
    addNewRegister: {
      get() {
        return this.addnew;
      },
      set() {},
    },
    validateForm() {
      return this.customerModel.customerName != "" && (this.customerModel.isOnlineCustomer ? true : this.customerModel.phone != "") && !this.errors.any();
    },
  },
  created() {
    this.getCountries();
    this.getCities();
    this.taxOffices();
    this.getCustomerTags();
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.$emit("hideAddNewRegister", false);
      }
    });
  },

  methods: {
    isAllValid: async function () {
      return await this.$validator.validateAll();
    },
    clearFields() {
      this.customerModel = {};
      this.$emit("hideAddNewRegister");
    },

    getCountries: async function () {
      await repository.getAll("B2B/getCountries").then((r) => (this.countries = r.list));
    },

    getCities: async function () {
      this.customerModel.city = 0;
      this.customerModel.county = 0;
      await repository.getAll("B2B/getCities").then((r) => {
        this.cities = r.list.filter((x) => x.countryId == this.customerModel.country);
      });
    },

    getCounties: async function () {
      this.customerModel.county = 0;
      await repository.getAll("B2B/getCounties").then((r) => {
        this.counties = r.list.filter((x) => x.cityId == this.customerModel.city);
      });
    },

    salesStaffFetch: async function () {
      this.salesStaff = await repository.getAll("B2B/salesStaff").then((r) => r.list);
    },

    taxOffices: async function () {
      this.taxOfficeList = await repository.getAll("B2B/getTaxOffices").then((r) => r.list);
    },

    getCustomerTags: async function () {
      this.customerTags = await repository.getAll("B2B/getCustomerTags").then((r) => r.list);
    },

    setCustomer: async function (d) {
      if (this.isAllValid()) {
        this.lockSaving = true;
        let taxNum = parseInt(d.taxNumber);
        let taxOff = parseInt(d.taxOffice);

        repository
          .postEntity("B2B/create", {
            name: d.customerName,
            region: "",
            taxNumber: taxNum,
            taxOffice: taxOff,
            address: d.address,
            country: d.country,
            city: d.city,
            county: d.county,
            phone: d.phone,
            email: d.customerMail,
            tags: d.tags ? d.tags : "",
            isOnlineCustomer: d.isOnlineCustomer,
            isSupplier: d.isSupplier,
          })
          .then((r) => {
            if (r.isSuccessful) {
              this.$emit("hideAddNewRegister", r.entity);
              this.clearFields();
              this.$vs.notify({
                color: "success",
                title: "Tamamlandı",
                text: `${d.customerName} Başarıyla kaydedildi.`,
              });
            } else if (r.hasExceptionError) {
              this.lockSaving = false;
              this.$vs.notify({
                color: "danger",
                title: "Hata",
                text: `${r.exceptionMessage}`,
              });
            } else {
              this.lockSaving = false;
              this.$vs.notify({
                color: "danger",
                title: "Hata",
                text: "Bilinmeyen bir hata meydana geldi",
              });
            }
          });
      } else
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Doğrulama başarısız.",
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#smallerDiv {
  .con-vs-dialog .vs-dialog {
    max-width: 50%;
  }
}
.vs__dropdown-menu {
  max-height: 150px;
}

@media screen and (max-width: 575px) {
  .mbl{
    margin-top:6px!important;
  }
}

</style>
